var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdentificationBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IdentificationBadge",
    clipPath: "url(#clip0_13836_27182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.5 12.3125C10.7426 12.3125 11.75 11.3051 11.75 10.0625C11.75 8.81986 10.7426 7.8125 9.5 7.8125C8.25736 7.8125 7.25 8.81986 7.25 10.0625C7.25 11.3051 8.25736 12.3125 9.5 12.3125Z",
    stroke: "#0095FF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.125 14C6.51796 13.476 7.02752 13.0508 7.61332 12.7579C8.19911 12.465 8.84506 12.3125 9.5 12.3125C10.1549 12.3125 10.8009 12.465 11.3867 12.7579C11.9725 13.0508 12.482 13.476 12.875 14",
    stroke: "#0095FF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.125 15.6875V3.3125C15.125 3.00184 14.8732 2.75 14.5625 2.75L4.4375 2.75C4.12684 2.75 3.875 3.00184 3.875 3.3125V15.6875C3.875 15.9982 4.12684 16.25 4.4375 16.25H14.5625C14.8732 16.25 15.125 15.9982 15.125 15.6875Z",
    stroke: "#0095FF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.25 5H11.75",
    stroke: "#0095FF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13836_27182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentificationBadge);
export default __webpack_public_path__ + "static/media/IdentificationBadge.5e5377abcc158e7da8b582d1f2e38b6a.svg";
export { ForwardRef as ReactComponent };